// FLO-54052: the uTest SPA runs from two origins - the marketing host (utest_url) and, once
// UTEST_APP_BASE_URL is flipped, the tester-app host root (utest_app_base_url). Only the origin of
// utest_app_base_url or of an entry in utest_app_hosts (extra tester origins such as vanity hosts)
// counts as the app host, and only once the two bases differ by origin; with no separate app base
// (ng serve, pre-cutover) this is always false. The utest_url origin is never an app host, even if
// listed in utest_app_hosts. Other origins (e.g. utest.com) are not app hosts.
export function isUtestAppHost(
  config: { utest_url?: string; utest_app_base_url?: string; utest_app_hosts?: string[] },
  origin: string,
): boolean {
  if (!config.utest_url || !config.utest_app_base_url) {
    return false;
  }
  const originOf = (url: string): string | null => {
    try {
      return new URL(url).origin;
    } catch {
      return null;
    }
  };
  const marketing = originOf(config.utest_url);
  const base = originOf(config.utest_app_base_url);
  if (!marketing || !base || marketing === base) {
    return false;
  }
  const appOrigins = [config.utest_app_base_url, ...(config.utest_app_hosts || [])]
    .map(originOf)
    .filter((o): o is string => !!o && o !== marketing);
  return appOrigins.includes(origin);
}
